<template>
    <el-main>
        <el-row>
            <el-col :span="16">
                <div class="main-title">
                    Device Activation &amp; Customer Information
                </div>
            </el-col>
        </el-row>

        <el-tabs style="margin-top: 24px;">
            <el-tab-pane v-loading="loadingCustomers">
                <span slot="label"><strong>Customer Record</strong></span>
                <div style="margin-top: 12px">
                    <el-card  style="margin-top: 24px"  class="box-card">
                        <div slot="header" class="clearfix">
                            <span>Filter</span>
                        </div>
                        <el-row :gutter="8">
                            
                            <el-col :span="4" class="filter-space">
                                <el-input v-model="filter.customer.email" size="small" placeholder="Email Address" class="filter-item"/>
                            </el-col>
                            <el-col :span="4" class="filter-space">
                                <el-input v-model="filter.customer.mobileNumber" size="small" placeholder="Mobile Number" class="filter-item"/>
                            </el-col>
                            <el-col :span="4" class="filter-space">
                                <el-input v-model="filter.customer.contractNumber" size="small" placeholder="Contract/Order Number" class="filter-item"/>
                            </el-col>
                            <el-col :span="4" class="filter-space">
                                <el-button  @click="searchCustomer" class="filter-item" size="small" type="primary" icon="el-icon-search">
                                    Search
                                </el-button>
                            </el-col>
                        </el-row>

                        
                    </el-card>

                    <el-card class="box-card" style="margin-top: 24px">
                        <el-table
                                :data="customers"
                                style="width: 100%"
                                @row-click="customerClicked"
                                >
                            <el-table-column
                                    property="email"
                                    label="Email"
                                    min-width="250"/>
                            <el-table-column
                                    property="contractNumbers"
                                    label="Contract Numbers"
                                    min-width="250">
                                    <template slot-scope="scope" >
                                        <div 
                                            v-for="item in scope.row.contractNumbers"
                                            :key="item">
                                            {{item}}
                                        </div>
                                    </template>
                            </el-table-column>
                            <el-table-column
                                    property="deviceCount"
                                    label="Device Count"
                                    min-width="180"/>
                            <el-table-column
                                    label="Joined Date"
                                    min-width="180">
                                    <template slot-scope="scope" >
                                        {{scope.row.createdDate | formatDate}}
                                    </template>
                            </el-table-column>
                            <el-table-column
                                    property="lastModifiedBy"
                                    label="Modified By"
                                    min-width="150"/>
                        </el-table>
                        <pagination v-show="customerQuery.total>0" :total="customerQuery.total" :page.sync="customerQuery.page" :limit.sync="customerQuery.limit" @pagination="searchCustomer" />
                    </el-card>
                </div>
            </el-tab-pane>
            <el-tab-pane  v-loading="loadingResetLogs">
                <span slot="label"><strong>Password Reset Activity</strong></span>
                <div  style="margin-top: 12px">
                    <el-card class="box-card" style="margin-top: 24px">
                        <el-table
                                :data="resetLogs"
                                style="width: 100%">
                            <el-table-column
                                    property="id"
                                    label="ID"
                                    width="180"/>
                            <el-table-column
                                    property="deviceID"
                                    label="Device ID"
                                    width="180"/>
                            <el-table-column
                                    label="Reset Date Time"
                                    width="160">
                                    <template slot-scope="scope" >
                                        {{scope.row.timestamp | formatDate}}
                                    </template>
                            </el-table-column>
                            <el-table-column
                                    property="country"
                                    label="Country"
                                    width="120"/>
                            <el-table-column
                                    property="city"
                                    label="City"
                                    width="150"/>
                            <el-table-column
                                    property="name"
                                    label="Name"
                                    width="150"/>
                            <el-table-column
                                    property="email"
                                    label="Email"
                                    min-width="180" />
                            <el-table-column
                                    property="author"
                                    label="Author"
                                    min-width="180" />
                            <el-table-column
                                    property="channel"
                                    label="Channel"
                                    width="120"/>
                        </el-table>
                        <pagination v-show="resetQuery.total>0" :total="resetQuery.total" :resetQuery.sync="query.page" :limit.sync="resetQuery.limit" @pagination="searchResetLog()" />
                    </el-card>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-main>
</template>

<script>
    import Pagination from "@/components/Pagination"
    import api from "@/services/api/WRCService"

    export default {
        components: { Pagination },
        data: function() {
            return {
                filter: {
                    customer: {
                        mobileNumber: null,
                        email: null,
                        contractNumber: null,
                        date: [new Date(2019, 10, 10, 10, 10), new Date(2019, 10, 11, 10, 10)],
                        city: null,
                        country: null,
                        searchingCountry: false,
                        searchingCity: false,
                        cities: [],
                        countries: []
                    },
                    password: {
                        date: [new Date(2019, 10, 10, 10, 10), new Date(2019, 10, 11, 10, 10)],
                        city: null,
                        country: null,
                        searchingCountry: false,
                        searchingCity: false,
                        cities: [],
                        countries: []
                    }
                },
                loadingCustomers: false,
                loadingResetLogs: false,
                customerQuery: {
                    
                    total: 3,
                    page: 1,
                    limit: 10
                },
                query: {
                    total: 3,
                    page: 1,
                    limit: 10
                },
                resetQuery: {
                    total: 0,
                    page: 1,
                    limit: 10
                },
                multipleSelection: [],
                customers: [],
                resetLogs: []
            }
        },
        methods:{
            searchCustomer() {
                this.loadingCustomers = true;

                api.getCustomers(this.filter.customer.email, this.filter.customer.mobileNumber, this.filter.customer.contractNumber, {
                    page: this.customerQuery.page - 1,
                    pageSize: this.customerQuery.limit
                }).then(({ data }) => {

                    this.customers.splice(0, this.customers.length);
                    this.customers.push(...data.data.items);
                    this.customerQuery.total = data.data.pagination.totalRecords;

                }).catch(() => {}).then(() => {
                    this.loadingCustomers = false;
                });
            },
            searchResetLog() {
                this.loadingResetLogs = true;

                api.getPasswordResetLogs(null, {
                    page: this.resetQuery.page - 1,
                    size: this.resetQuery.limit
                }).then(({ data }) => {

                    this.resetLogs.splice(0, this.resetLogs.length);
                    this.resetLogs.push(...data.data.items);
                    this.resetQuery.total = data.data.pagination.totalRecords;

                }).catch(() => {}).then(() => {
                    this.loadingCustomers = false;
                });
            },
            customerClicked(row, column, event) {
                //console.log('row clicked: ' + row.id);
                var customerId = row.id
                this.$router.push({ name: 'CustomerEdit', params: { customerId } })
            },
            loadData(){

            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            searchCustomerCountry(query) {
                this.filter.customer.searchingCountry = true;
                api.getCountries(query, {
                    page: 0,
                    size: 200
                }).then(({data}) => {
                    this.filter.customer.countries.splice(0, this.filter.customer.countries.length);
                    if(query === ''){
                        this.filter.customer.countries.push({
                            id: null,
                            name: 'Select Country'
                        });

                        this.filter.customer.country = null;
                    }
                    this.filter.customer.countries.push(...data.data.items);
                }).catch(() => {}).then(() => {
                    this.filter.customer.searchingCountry = false;
                });
            },
            searchCustomerCity(query) {
                this.filter.customer.city = null;
                this.filter.customer.searchingCity = true;
                api.getCities({
                    name: query,
                    countryId: this.filter.customer.country
                }, {
                    page: 0,
                    size: 100
                }).then(({data}) => {

                    this.filter.customer.cities.splice(0, this.filter.customer.cities.length);
                    if(query === '') {
                        this.filter.customer.cities.push({
                            id: null,
                            name: 'Select City'
                        });
                        this.filter.customer.city = null;
                    }
                    this.filter.customer.cities.push(...data.data.items);
                }).catch(() => {
                }).then(() => {
                    this.filter.customer.searchingCity = false;
                });
            },
            searchPasswordCountry(query) {
                this.filter.password.searchingCountry = true;
                api.getCountries(query, {
                    page: 0,
                    size: 200
                }).then(({data}) => {
                    this.filter.password.countries.splice(0, this.filter.password.countries.length);
                    if(query === ''){
                        this.filter.password.countries.push({
                            id: null,
                            name: 'Select Country'
                        });

                        this.filter.password.country = null;
                    }
                    this.filter.password.countries.push(...data.data.items);
                }).catch(() => {}).then(() => {
                    this.filter.password.searchingCountry = false;
                });
            },
            searchPasswordCity(query) {
                this.filter.password.city = null;
                this.filter.password.searchingCity = true;
                api.getCities({
                    name: query,
                    countryId: this.filter.password.country
                }, {
                    page: 0,
                    size: 100
                }).then(({data}) => {

                    this.filter.password.cities.splice(0, this.filter.password.cities.length);
                    if(query === '') {
                        this.filter.password.cities.push({
                            id: null,
                            name: 'Select City'
                        });
                        this.filter.password.city = null;
                    }
                    this.filter.password.cities.push(...data.data.items);
                }).catch(() => {
                }).then(() => {
                    this.filter.password.searchingCity = false;
                });
            },
        },
        mounted() {
            this.searchCustomer();
            this.searchResetLog();
            this.searchCustomerCountry('');
            this.searchCustomerCity('');
            this.searchPasswordCountry('');
            this.searchPasswordCity('');
        }
    }
</script>

<style scoped>

</style>
